import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import BaiduMap from "vue-baidu-map";
import axios from "axios";

import "./vant"; // @H5.vant
import "./styles/reset.css";

import { Toast } from "vant";
Vue.prototype.$toast = Toast;

import wx from "weixin-js-sdk";
Vue.use(wx);
Vue.prototype.$wx = wx;

// import "amfe-flexible";
// import "lib-flexible";
import "./utils/rem.js";

// import $ from 'jquery'
import htmlToPdf from "@/utils/htmlToPdf";
import Print from "@/utils/print";
// import "amfe-flexible";
import preventReClick from "@/utils/util";

//在main.js内
import Vconsole from "vconsole";
// 开发环境使用，生产环境自动取消
if (process.env.NODE_ENV == "development") {
  // new Vconsole();
}

Vue.use(preventReClick);

import { Cascader } from "vant";
Vue.use(Cascader);

import { Badge } from "vant";
Vue.use(Badge);

Vue.use(Print);
Vue.use(htmlToPdf);
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
Vue.prototype.$filePath = process.env.VUE_APP_FILE_URL;
Vue.use(ElementUI);
Vue.use(BaiduMap, {
  ak: "5iZVU2TpODpAD3ocXkwmgGS8mNDcqW0U",
});
// Vue.use($)

// 正式环境清除所有console.log
if (process.env.NODE_ENV === "production") {
  if (window) {
    window.console.log = function () {};
  }
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
